/*
 * NOTE: This is an auto-generated file created by Iconic.
 *
 * You should not need to edit this file directly; if you need to add/remove any
 * icon modules, you can rebuild it by running `yarn icons:make`.
 */
import * as React from 'react'

import VacasaWrapper from '../Wrapper'

const VacasaAlertTriangle3: React.FunctionComponent = () => {
  return (
    <VacasaWrapper id="alertTriangle3" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="12" fill="#F5F7F8"></circle>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4276 5.66931C10.7556 5.12851 11.3391 4.79999 11.9683 4.79999C12.5975 4.79999 13.181 5.12851 13.509 5.66931L18.5959 14.1616C18.9157 14.7155 18.9176 15.3974 18.6009 15.9531C18.2842 16.5087 17.6964 16.8546 17.0503 16.8616L6.87972 16.8616C6.24019 16.8546 5.65242 16.5087 5.3357 15.9531C5.01899 15.3974 5.0209 14.7155 5.34559 14.1533L10.4276 5.66931ZM6.37991 14.7617C6.2733 14.9463 6.27266 15.1736 6.37824 15.3588C6.48381 15.544 6.67973 15.6593 6.88631 15.6616L17.0437 15.6617C17.2569 15.6593 17.4528 15.544 17.5584 15.3588C17.664 15.1736 17.6633 14.9463 17.5616 14.77L12.4813 6.28881C12.3725 6.1095 12.178 5.99999 11.9683 5.99999C11.759 5.99999 11.5649 6.10902 11.456 6.28763L6.37991 14.7617ZM11.3683 9.06163C11.3683 8.73026 11.6369 8.46163 11.9683 8.46163C12.2997 8.46163 12.5683 8.73026 12.5683 9.06163V11.4616C12.5683 11.793 12.2997 12.0616 11.9683 12.0616C11.6369 12.0616 11.3683 11.793 11.3683 11.4616V9.06163ZM11.544 13.6859C11.3097 13.4516 11.3097 13.0717 11.544 12.8374C11.7784 12.6031 12.1583 12.6031 12.3926 12.8374C12.6269 13.0717 12.6269 13.4516 12.3926 13.6859C12.1583 13.9202 11.7784 13.9202 11.544 13.6859Z"
        fill="#DDAD49"
      ></path>
    </VacasaWrapper>
  )
}

export default React.memo(VacasaAlertTriangle3)
